import { render, staticRenderFns } from "./StudyConversationMessagePoll.vue?vue&type=template&id=31fd8dc8&scoped=true"
import script from "./StudyConversationMessagePoll.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessagePoll.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessagePoll.vue?vue&type=style&index=0&id=31fd8dc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd8dc8",
  null
  
)

export default component.exports